
  (function () {
    'use strict';

    /* ── Element refs ── */
    const megaTrigger = document.querySelector('[data-mega-trigger]');
    const megaMenu = document.querySelector('[data-mega-menu]');
    const drawer = document.querySelector('[data-drawer]');
    const drawerOverlay = document.querySelector('[data-drawer-overlay]');
    const headerWrapper = document.querySelector('.section-header.shopify-section-group-header-group');
    
    if (!headerWrapper) return;

    /* =============================================
       MEGA MENU (desktop)
       ============================================= */
    let megaCloseTimer = null;

    function openMega() {
      clearTimeout(megaCloseTimer);
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      megaTrigger.setAttribute('aria-expanded', 'true');
    }

    function closeMega() {
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      megaTrigger.setAttribute('aria-expanded', 'false');
    }

    function scheduleMegaClose() {
      megaCloseTimer = setTimeout(closeMega, 150);
    }

    if (megaTrigger && megaMenu) {
      /* Hover — open on enter, close on leave with delay */
      megaTrigger.closest('.brave-header__nav-item').addEventListener('mouseenter', openMega);
      megaTrigger.closest('.brave-header__nav-item').addEventListener('mouseleave', scheduleMegaClose);
      megaMenu.addEventListener('mouseenter', function () {
        clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('mouseleave', scheduleMegaClose);

      /* Click toggle for touch-screen desktops */
      megaTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (megaMenu.classList.contains('is-open')) {
          closeMega();
        } else {
          openMega();
        }
      });

      /* Escape key closes mega */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && megaMenu.classList.contains('is-open')) {
          closeMega();
          megaTrigger.focus();
        }
      });

      /* Click outside closes mega */
      document.addEventListener('click', function (e) {
        if (megaMenu.classList.contains('is-open') && !megaMenu.contains(e.target) && !megaTrigger.contains(e.target)) {
          closeMega();
        }
      });
    }

    /* =============================================
       MOBILE DRAWER
       ============================================= */
    const drawerOpenBtns = document.querySelectorAll('[data-drawer-open]');
    const drawerCloseBtns = document.querySelectorAll('[data-drawer-close]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      /* Set hamburger state */
      drawerOpenBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      drawerOpenBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    drawerOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    drawerCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

    /* Drawer accordions */
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var key = this.getAttribute('data-accordion-trigger');
        var content = document.querySelector('[data-accordion-content="' + key + '"]');
        var isOpen = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        content.classList.toggle('is-open');
      });
    });

    /* Escape closes drawer */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

  var lastScrollY = 0;
  var headerHeight = headerWrapper.offsetHeight;
  var ticking = false;

  function onScroll() {
    var currentScrollY = window.pageYOffset;
    if (currentScrollY <= 0) {
      /* At top — reset */
      headerWrapper.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY && currentScrollY > headerHeight) {
      /* Scrolling down past header — hide */
      headerWrapper.classList.add('is-hidden');
      /* Close mega if open */
      if (megaMenu && megaMenu.classList.contains('is-open')) closeMega();
    } else if (currentScrollY < lastScrollY) {
      /* Scrolling up — reveal */
      headerWrapper.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  document.addEventListener('scroll', onScroll, true);
})();

window.addEventListener('postscriptPopup', function (event) {
  const detail = event.detail || {};

  // Only track submission steps containing an email
  if (
    detail.type !== 'formSubmit' ||
    !detail.values ||
    !detail.values.email
  ) {
    return;
  }

  if (typeof window.fbq !== 'function') {
    console.error(
      'Postscript email submitted, but Meta Pixel fbq is not available.'
    );
    return;
  }

  window.fbq('track', 'Lead', {
    content_name: 'Postscript Email Popup',
    popup_id: String(detail.popupId || ''),
    popup_name: detail.popupName || ''
  });
});

// This is a function for expanding description blocks
for (let expandEl of document.getElementsByClassName("expand-section")) {
  expandEl.addEventListener("click", function () {
    var idElementToExpand = expandEl.getAttribute("section-to-expand");
    var containerElement = document.getElementById(idElementToExpand);
    var containerScrollState = containerElement.getAttribute("aria-expanded");
    var elementHeight = containerElement.scrollHeight;
    var readMoreFade = document.querySelector(
      `#${idElementToExpand} .read-more-fade`
    );
    var readMoreButton = document.querySelector(
      `#${idElementToExpand} + .read-more-button`
    );

    if (
      containerScrollState === "false" ||
      idElementToExpand == "fibc-info-dropdown"
    ) {
      containerElement.style.maxHeight = elementHeight + "px";
      if (readMoreFade) {
        readMoreFade.style.display = "none";
        readMoreButton.innerHTML = "Read less";
      }
      containerElement.setAttribute("aria-expanded", "true");
    } else {
      containerElement.style.maxHeight = "250px";
      if (readMoreFade) {
        readMoreFade.style.display = "block";
        readMoreButton.innerHTML = "Read more";
      }
      containerElement.setAttribute("aria-expanded", "false");
    }
  });
}

// PRODUCT MEDIA IMAGE SCROLL
let clickTracker = 0;
function productMediaSelect(mediaIndex, elContainer) {
  clickTracker = mediaIndex;
  const currentScrollPosition = $(`#${elContainer}`).width();
  $(`#${elContainer}`).scrollLeft(currentScrollPosition * mediaIndex);
}

// SCROLL FUNCTION
function elementScroll(direction, containerId) {
  const elWidth = $(`#${containerId}`).width();
  const containerEl = document.getElementById(containerId);
  if (direction == "forward") {
    // Count ELEMENTS, not childNodes. childNodes includes whitespace text
    // nodes, so the old `(childNodes.length - 1) / 2` only equalled the slide
    // count when every slide happened to be separated by whitespace — i.e. when
    // the markup was built with plain `{% for %}`. Any template using Liquid's
    // whitespace-stripping tags (`{%- ... -%}`) emits no text nodes between
    // slides, the divisor collapsed to roughly half, and the forward arrow died
    // partway along while the back arrow (guarded on >= 0) kept working.
    // Hit on page.offer-lander-iggy-bundle: 6 slides, 7 childNodes, forward
    // stopped after 2 clicks. Equivalent to the old expression for every
    // whitespace-separated carousel in the theme, so this is a safe swap.
    if (clickTracker + 1 < containerEl.children.length) {
      clickTracker++;
      containerEl.scrollLeft = elWidth * clickTracker;
    }
  } else {
    if (clickTracker - 1 >= 0) {
      clickTracker--;
      containerEl.scrollLeft = elWidth * clickTracker;
    }
  }
}

var onPageUpsellVid;
var onPageUpsellLineProperty;
var radioBtn;
function upsellCardClicked(vid, prop) {
  onPageUpsellVid = vid;
  onPageUpsellLineProperty = prop;
  radioBtn = $("#upsell-card-check");

  if (radioBtn.attr("isChecked") == "yes") {
    $("#upsell-card-check svg").css("display", "none");
    radioBtn.attr("isChecked", "no");
  } else {
    $("#upsell-card-check svg").css("display", "block");
    radioBtn.attr("isChecked", "yes");
  }
}

// Skio Customer Portal - Customizations Script
const variantTitle = "Next Month's Book";
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.includes("/a/account/")) {
    let lastUrl = window.location.href; 
    skioOnUrlChange(lastUrl);
    new MutationObserver(() => {
      let url = window.location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        skioOnUrlChange(lastUrl, url);
      }
    }).observe(document, {subtree: true, childList: true});
  }
});

function skioOnUrlChange(lastUrl, url = '') {
  if (url == '') url = lastUrl;
  if (!url.includes("/a/account/login")) {
    skioWaitForElm('#__next .SubscriptionGroup-Active h3').then(() => {
      setTimeout( function() {
        skioRemoveButtons();
      }, 200);
    });
  }
  if (url.includes("/a/account/subscriptions") || url.includes("/a/account/login")) {
    document.querySelector("#__next").style.paddingTop = "40px";
    skioWaitForElm('#__next .SubscriptionGroup-Active h3').then(() => {
      setTimeout( function() {
        skioRemoveButtons();
      }, 200);
    });
  }
}

function skioRemoveButtons() {
  console.log("skio remove buttons");
  let cards = document.querySelectorAll('#__next .SubscriptionCard');
  cards.forEach((card) => {
    console.log("for each card");
    let foundProduct = false;
    let bodys = card.querySelectorAll('.SubscriptionBody');
    bodys.forEach((body) => {
      console.log("for each body");
      foundProduct = skioElementContainsSubstring(body, variantTitle);
      console.log("found? ", foundProduct, body);
    });
    if (foundProduct) {
      let nextOrderDate = card.querySelector('[aria-label="Set your next order date"]');
      if (nextOrderDate) nextOrderDate.parentNode.remove();
      let get_now = card.querySelector('[aria-label="Order Now"]');
      if (get_now) get_now.parentNode.remove();
      card.classList.add("last-book-in-series");
    }
  });
}

function skioElementContainsSubstring(element, substring) {
  const childElements = element.querySelectorAll("*");
  for (const child of childElements) {
      if (child.textContent.includes(substring)) return true;
  }
  return false;
}

function skioWaitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
